import React, {FunctionComponent, useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {IState} from '../../../../../shared/store/reducers';
import {
  loadCurrentOrganization, saveOrganization
} from '../../../../../shared/store/actions/organizationActions';
import OnboardingDialog from './OnboardingDialog';
import {saveUser} from "../../../../../shared/store/actions/userActions";
import {ApiStatus} from "../../../../../shared/models";
import config from "../../../../../config";
import {isAdmin} from "../../../../../shared/utils/auth";
import {useCurrentUser} from "../../../../../shared/hooks";
import {isAtLeast24HoursAgo} from "../../../../../shared/utils/date";

interface IOnboardingDialogContainer {
}

const OnboardingDialogContainer: FunctionComponent<IOnboardingDialogContainer> = ({}: IOnboardingDialogContainer) => {
  const [save, setSave] = useState(false);
  const [saved, setSaved] = useState(false);
  const organization = useSelector((state: IState) => state.organizations.organization);
  const updatingOrganization = useSelector((state: IState) => state.organizations.savingStatus);
  const currentUser = useCurrentUser();
  const updatingUser = useSelector((state: IState) => state.users.savingStatus);
  const dispatch = useDispatch();

  const [showOnboardingDialog, setShowOnboardingDialog] = useState(false)

  useEffect(() => {
    if (
      isAdmin(currentUser)
      && !currentUser?.accepted_terms_on
      && isAtLeast24HoursAgo(currentUser?.created_on)
    ) {
      setShowOnboardingDialog(true)
    }
  }, [currentUser])

  const onCloseShowOnboardingDialog = () => {
    setShowOnboardingDialog(false)
  }

  useEffect(() => {
    dispatch(loadCurrentOrganization());
  }, []);

  useEffect(() => {
    if (save && updatingOrganization === ApiStatus.LOADED && updatingUser === ApiStatus.LOADED) {
      setSaved(true);
      setSave(false);
    }
  }, [save, updatingOrganization, updatingUser]);

  const onSubmit = useCallback((formState: any) => {
    const {
      firstName,
      lastName,
      companyName,
    } = formState;

    dispatch(saveUser({
      uid: currentUser?.uid,
      accepted_terms_on: !currentUser?.accepted_terms_on ? new Date() : undefined,
      first_name: firstName,
      last_name: lastName
    }));

    dispatch(saveOrganization({
      uid: organization?.uid,
      name: companyName,
    }));

    if (config.segment.enabled && window.analytics) {
      const currentOrganizationUid = currentUser?.current_organization_uid || '';

      const options = {
        context: {
          groupId: currentOrganizationUid,
        }
      }

      window.analytics.track(
        "profile_completed", options
      )
    }

    setSave(true);
  }, [currentUser, organization]);


  return (
    <OnboardingDialog
      saved={saved}
      organization={organization}
      currentUser={currentUser}
      onSubmit={onSubmit}
      show={showOnboardingDialog}
      onClose={onCloseShowOnboardingDialog}
    />
  )
};

export default OnboardingDialogContainer;
